import styled from "styled-components/macro";

import { useFnrSelectList3 } from "../FnrSelectList3Context";

export default function RightDownArrow({ style }) {
  const {
    state: { show },
  } = useFnrSelectList3();

  return (
    <SelectIcon
      style={style}
      className={show ? "fas fa-chevron-right rotate" : "fas fa-chevron-right"}
    />
  );
}

const SelectIcon = styled.span`
  font-size: 16px;
  margin-left: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 75ms;

  &.rotate {
    transform: rotate(90deg);
  }
`;
